import React from 'react';
import classNames from 'classnames';

import type { VideoProps } from './video.props';

import './video.scss';

const Video = ({ className, height, title, src, width }: VideoProps) => {
  return (
    <div className={classNames('video', className)}>
      <iframe
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="video__frame"
        height={height}
        src={src}
        title={title}
        width={width}
      ></iframe>
    </div>
  );
};

export default Video;
